import Vue from "vue";
import data from "../../data/data";
import firebase from "firebase";
import user from "./user";
const fb = require("../../../firebaseConfig.js");

const state = {
    recipes: {},
    sections: {},
    ingredients: {},
    directions: {},
    //userProfile: {},
    recipesLoaded: false
};

const mutations = {
    SET_RECIPES(state, data) {
        // set data from data.js
        /*state.recipes = data.recipes;
        state.sections = data.sections;
        state.ingredients = data.ingredients;
        state.directions = data.directions;*/

        // get each collection from the database and set the state
        let promise1 = fb.recipesCollection.get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                Vue.set(state.recipes, doc.id, doc.data());
                const imageName = state.recipes[doc.id].imageName;
                console.log(doc.data().imageName, imageName);

                let storageRef = firebase.storage().ref();
                let pathReference = storageRef.child(imageName);
                //console.log(storageRef, pathReference);

                pathReference.getDownloadURL().then(function(url) {
                    console.log(url);
                    state.recipes[doc.id].imageUrl = url;
                });
            });
        });

        let promise2 = fb.sectionsCollection
            .get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    Vue.set(state.sections, doc.id, doc.data());
                });
            });

        let promise3 = fb.ingredientsCollection
            .get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    Vue.set(state.ingredients, doc.id, doc.data());
                });
            });

        let promise4 = fb.directionsCollection
            .get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    Vue.set(state.directions, doc.id, doc.data());
                });
            });

        let promise5 = fb.usersCollection.get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                Vue.set(user.state.users, doc.id, doc.data());
            });
        });

        Promise.all([promise1, promise2, promise3, promise4, promise5]).then(
            () => {
                state.recipesLoaded = true;
            }
        );
    },

    /*UPDATE_RECIPE(state, data) {},*/

    ADD_RECIPE(state, data) {
        // loop through the new sections and add each new section
        for (var section in data.newSections) {
            let idString = section.toString();

            Vue.set(state.sections, idString, data.newSections[section]);
        }

        // loop through the new directions and add each new direction
        for (var direction in data.newDirections) {
            let idString = direction.toString();

            Vue.set(state.directions, idString, data.newDirections[direction]);
        }

        // loop through the new ingredients and add each new ingredient
        for (var ingredient in data.newIngredients) {
            let idString = ingredient.toString();

            Vue.set(
                state.ingredients,
                idString,
                data.newIngredients[ingredient]
            );
        }

        // hit the database and add recipe

        // add the new recipe to our state.recipes
        Vue.set(state.recipes, data.newRecipe.id, data.newRecipe);
        //state.recipes[data.newRecipe.id] = data.newRecipe;

        // save to the database
        //db.collection('recipes')
        fb.recipesCollection.doc(data.newRecipe.id).set(data.newRecipe);

        /*if (data.author !== undefined) {
            state.users[data.author].push(data.newRecipe.id);
            fb.usersCollection.doc(data.author)
                .add(data.newRecipe.id);
        }*/

        // loop through sections, ingredients, and directions to save each one
        for (var section in data.newSections) {
            //db.collection('sections')
            fb.sectionsCollection.doc(section).set(data.newSections[section]);
        }

        for (var ingredient in data.newIngredients) {
            //db.collection('ingredients')
            fb.ingredientsCollection
                .doc(ingredient)
                .set(data.newIngredients[ingredient]);
        }

        for (var direction in data.newDirections) {
            //db.collection('directions')
            fb.directionsCollection
                .doc(direction)
                .set(data.newDirections[direction]);
        }
    }
};

const actions = {
    addRecipe: ({ commit }, recipe) => {
        commit("ADD_RECIPE", recipe);
    },
    removeRecipe: ({ commit }, recipe) => {
        commit("REMOVE_RECIPE", recipe);
    },
    updateRecipe: ({ commit }, recipe) => {
        commit("UPDATE_RECIPE", recipe);
    },
    initRecipes: ({ commit }) => {
        commit("SET_RECIPES", data);
    },
    signOut: ({ commit }) => {
        firebase.auth().signOut();
    },
    clearRecipeData: ({ commit }) => {
        commit("SET_RECIPES", null);
    }
};

const getters = {
    recipes: state => {
        return state.recipes;
    },
    recipeById: state => {
        const recipes = Object.values(state.recipes);

        return recipeId => {
            return recipes.find(recipe => recipe.urlId === recipeId);
        };
    },
    sections: state => {
        return state.sections;
    },
    recipeSections: state => {
        const sections = Object.values(state.sections);

        return recipeId => {
            console.log(recipeId);
            return sections.filter(section => section.recipeId === recipeId);
        };
    },
    ingredients: state => {
        return state.ingredients;
    },
    recipeIngredients: state => {
        const ingredients = Object.values(state.ingredients);

        return recipeId => {
            return ingredients.filter(
                ingredient => ingredient.recipeId === recipeId
            );
        };
    },
    directions: state => {
        return state.directions;
    },
    recipeDirections: state => {
        const directions = Object.values(state.directions);

        return recipeId => {
            return directions.filter(
                direction => direction.recipeId === recipeId
            );
        };
    },
    recipesLoaded: state => {
        return state.recipesLoaded;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};